module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/coj_b-2-628a049c4eb72162ab1ca8621fbdf8a2.jpg";